module.exports = __webpack_public_path__ + "static/media/23.2c7d9e44.svg";